var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFamily = function SvgFamily(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36.199,
    height: 28.748,
    viewBox: "0 0 36.199 28.748",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1804",
    "data-name": "Group 1804",
    transform: "translate(-541.686 -317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26176",
    "data-name": "Path 26176",
    d: "M1115.458,65.089a6.294,6.294,0,1,1,6.288-6.295A6.29,6.29,0,0,1,1115.458,65.089Zm15.729,0a1.569,1.569,0,0,1-1.567-1.574V60.368h-3.153a1.574,1.574,0,0,1,0-3.147h3.153V54.074a1.568,1.568,0,0,1,1.567-1.574,1.585,1.585,0,0,1,1.586,1.574v3.147h3.134a1.574,1.574,0,1,1,0,3.147h-3.134v3.147A1.585,1.585,0,0,1,1131.187,65.089Z",
    transform: "translate(-559.61 264.5)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26177",
    "data-name": "Path 26177",
    d: "M1105,72.162c.6-7.51,6.7-11.329,14.143-11.329,7.534,0,13.709,3.609,14.181,11.33a1.083,1.083,0,0,1-1.189,1.259h-25.982A1.741,1.741,0,0,1,1105,72.162Z",
    transform: "translate(-563.314 272.327)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFamily, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/family.9a48624c.svg";
export { ForwardRef as ReactComponent };